import { ChevronRight } from 'lucide-react'

export interface Crumb {
  label: string
  /** Sem href = página atual, último item da trilha. */
  href?: string
}

/**
 * Trilha das páginas públicas. Deliberadamente simples: só links e separadores.
 * O último item não é link e recebe aria-current, que é o que leitor de tela usa
 * para anunciar "você está aqui".
 */
export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Trilha de navegação">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground">
        {items.map((item, index) => {
          const last = index === items.length - 1

          return (
            <li
              key={`${item.label}-${index}`}
              className="flex items-center gap-1"
            >
              {index > 0 && (
                <ChevronRight
                  className="h-3.5 w-3.5 shrink-0 opacity-50"
                  aria-hidden="true"
                />
              )}
              {item.href && !last ? (
                <a
                  href={item.href}
                  className="transition-colors hover:text-foreground hover:underline"
                >
                  {item.label}
                </a>
              ) : (
                <span
                  className="font-medium text-foreground"
                  aria-current={last ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
